import './ComboClearButton.css';

interface ComboClearButtonProps {
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  /** По умолчанию «Очистить» */
  'aria-label'?: string;
}

export function ComboClearButton({ onClick, className, 'aria-label': ariaLabel = 'Очистить' }: ComboClearButtonProps) {
  return (
    <button
      type="button"
      className={`combo-clear-btn ${className ?? ''}`.trim()}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      ×
    </button>
  );
}
